import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { motion } from "framer-motion";
import { Clock, ArrowUpRight } from "lucide-react";

const Library = () => {
  const [articles, setArticles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [active, setActive] = useState("all");

  useEffect(() => {
    api.get("/articles").then((r) => {
      setArticles(r.data.articles);
      setCategories(["all", ...r.data.categories]);
    });
  }, []);

  const filtered = active === "all" ? articles : articles.filter((a) => a.category === active);

  return (
    <div className="max-w-6xl mx-auto px-6 py-10">
      <div className="overline mb-2">THE LIBRARY</div>
      <h1 className="font-serif text-4xl sm:text-5xl mb-6" data-testid="library-title">
        The <span className="italic text-amber-500">playbook.</span>
      </h1>
      <p className="text-neutral-400 max-w-2xl mb-8">Chapters on approach, texting, ghosting, first dates, long-term love, and mindset. Read what fits your moment.</p>

      <div className="flex flex-wrap gap-2 mb-10">
        {categories.map((c) => (
          <button
            key={c}
            onClick={() => setActive(c)}
            data-testid={`cat-${c.toLowerCase()}`}
            className={`px-4 py-2 rounded-full text-sm border transition-colors ${
              active === c ? "border-amber-500 text-amber-400 bg-amber-500/10" : "border-white/10 text-neutral-400 hover:text-white"
            }`}
          >
            {c === "all" ? "All" : c}
          </button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {filtered.map((a, i) => (
          <motion.div
            key={a.id}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.04 }}
          >
            <Link to={`/article/${a.id}`} className="block card-surface p-8 hover-lift" data-testid={`article-card-${a.id}`}>
              <div className="flex items-center justify-between mb-3">
                <span className="overline text-amber-500">{a.category}</span>
                <span className="text-xs text-neutral-500 inline-flex items-center gap-1"><Clock className="w-3 h-3" /> {a.read_time} min</span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl mb-3 leading-tight">{a.title}</h2>
              <p className="text-neutral-400 leading-relaxed">{a.excerpt}</p>
              <div className="mt-5 inline-flex items-center gap-2 text-amber-500 text-sm">Read chapter <ArrowUpRight className="w-4 h-4" /></div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Library;
